import { useQueryClient } from "@tanstack/react-query";
import { markAlertActionPerformed } from "web_myplann/Api/Portfolio/markAlertActionPerformed";
import { useCalculatorLead } from "web_myplann/Calculators/Hooks/useCalculatorLead";
import { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import {
	AlertBoxActionEnum,
	AlertBoxActionStateEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const useRefinancingLead = (contractId: number | undefined) => {
	const queryClient = useQueryClient();

	return useCalculatorLead(CalculatorType.Refinancing, {
		onSent: () => {
			if (contractId === undefined) {
				return;
			}

			markAlertActionPerformed(
				queryClient,
				contractId,
				AlertBoxActionEnum.CompareRates,
				AlertBoxActionStateEnum.Sent,
			);
		},
	});
};
